import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'ridango-arrow-down-separator',
  templateUrl: './arrow-down-separator.component.html',
  styleUrls: ['./arrow-down-separator.component.scss']
})
export class ArrowDownSeparatorComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
